<template>
  <div class="article">
    <HeaderComponent/>
    <div class="slogan">
      <img src="https://cyvideo.i-oranges.com/home/12.jpg"  alt="">
    </div>
    <div class="slogan" v-for="d in ImgData">
      <img :src="d.url" v-if="d.type =='jpg'||d.type =='png'||d.type =='gif'">
      <video v-else muted controls autoplay class="wid100" :src="d.url"></video>
    </div>
<!--    <ProjectComponent/>-->
    <ServiceComponent/>
    <FooterComponent/>
    <BackToTop :visibility-height="500" :bottom="50" :right="50"/>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent'
import FooterComponent from '../components/FooterComponent'
import ProjectComponent from '../components/ProjectComponent'
import ServiceComponent from '../components/ServiceComponent'
import {getByWork} from "../api/article";


export default {
  name: "articles",
  components: {
    HeaderComponent,

    FooterComponent,
    ProjectComponent,
    ServiceComponent,

  },data(){
    return{
      ImgData:[]
    }
  },
  mounted() {
    getByWork(this.$route.query.id).then(res=>{
      let data =  res.data;
      // this.ImgData= {
      //   url: data.workUrl.split(','),
      //   content: data.content
      // };
      this.ImgData = data.workMap;
      console.log(data)
      // console.log(data.workMap)
    })

  },
  methods:{

  }
}
</script>

<style scoped>
.article {
  width: 100%;
}

.slogan {
  width: 76%;
  margin: 0 auto;
}

.slogan img {
  width: 100%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/view/article.vue